<!-- views/WechatCallback.vue -->
<template>
  <div style="text-align: center; padding: 40px;">
    <p>微信登录成功，正在处理...</p>
  </div>
</template>

<script>


import config from "../../config/config";

export default {
  name: 'WechatCallback',
  mounted() {
    // 1. 获取当前完整 URL
    const currentUrl = window.location.href;
    let queryParams = window.location.search;
    if (!queryParams && window.location.hash.includes('?')) {
      // 从 hash 中提取查询参数
      const hashParts = window.location.hash.split('?');
      if (hashParts.length > 1) {
        queryParams = '?' + hashParts[1];
      }
    }
    // 2. 解析 URL 参数（如 code, state）
    const urlParams = new URLSearchParams(queryParams);
    const code = urlParams.get('code');
    // 4. 发送消息给打开这个窗口的主页面
    if (window.opener && !window.opener.closed) {
      // ✅ 关键：发送消息
      window.opener.postMessage(
        {
          type: 'WECHAT_LOGIN_REDIRECT',
          data: { 'code': code }
        },
        config.BASE_URL
      );
    }
    // 5. 延迟关闭弹窗
    setTimeout(() => {
      window.close();
    }, 1500);
  },
  methods: {
    clearList() {
      const allTabs = this.$store.getters["router/tabs"]
      const closeableTabs = allTabs.filter(
        (tab) => tab.path !== "/user/user-center"
      );
      if (closeableTabs.length !== 0) {
        closeableTabs.forEach((tab) => {
          this.$store.dispatch("router/closeTab", tab.path);
        });
      }
    },
  }
};
</script>
